import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormatLineSpacing } from '@material-ui/icons';
import cx from 'classnames';
import { motion, AnimatePresence } from "framer-motion";
import { MARKS, LINE_HEIGHT_OPTIONS } from '../../../constants';
import PopupWrapper from '../../PopupWrapper';

class LineHeight extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };

    this.togglePopup = this.togglePopup.bind(this);
    this.heightOnClick = this.heightOnClick.bind(this);
  }

  togglePopup() {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  }

  heightOnClick(event) {
    event.preventDefault();
    const lineHeight = Number(event.currentTarget.dataset.height);

    // first find all line height marks on the selected text and remove them
    this.props.value.marks.forEach(mark => {
      const currentMarkHeight = mark.data.get('lineHeight');
      this.props.editor.removeMark({
        type: MARKS.LINE_HEIGHT,
        data: { lineHeight: currentMarkHeight },
      });
    });

    // then add the new incoming line height mark
    if (lineHeight !== 'Default') {
      this.props.editor.addMark({
        type: MARKS.LINE_HEIGHT,
        data: { lineHeight },
      });
    }

    this.togglePopup();
  }

  render() {
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--lineheight">
          <button
            title="Vertical Spacing"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
            <FormatLineSpacing />
          </button>
          <AnimatePresence>
            {this.state.showPopup &&
            <motion.div
              initial={{ opacity: 0, y: '80%' }}
              animate={{ opacity: 1, y: '100%' }}
              exit={{ opacity: 0, y: '80%' }}
              transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: .3 }}
              className="icon__popup icon__popup--lineheight icon__popup--range">
              <ul
                ref={ul => (this.ul = ul)}
                className="list-reset m-0 overflow-y-scroll">
                {LINE_HEIGHT_OPTIONS.map(height => {
                  return (
                    <li key={height}>
                      <button
                        data-height={height}
                        onClick={this.heightOnClick}
                        className="bg-white border-0 px-4 py-2 text-sm w-full outline-none cursor-pointer">
                        {height}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </motion.div>}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  LineHeight;
